(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"26241c3"};


//////////////////
// WEBPACK FOOTER
// /~/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 96
// module chunks = 1